import { classics } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function ClassicsSection() {
  return (
    <section id="classics" className="scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="CLASSICS"
          title="经典老剧：值得反复重温的那些年"
          desc="按年代整理的一批经典老剧与老电影，画面带着胶片年代的质感，故事却依然耐看。适合放慢节奏，一次两三集地慢慢回味。"
        />

        <div className="mt-10 grid grid-cols-2 gap-4 md:grid-cols-3 md:gap-6">
          {classics.map((item, index) => (
            <article
              key={item.id}
              className={`group relative overflow-hidden rounded-lg border border-background-200/70 bg-background-100 ${
                index === 0 ? "col-span-2 md:col-span-1" : ""
              }`}
            >
              <div className="relative aspect-[16/10] w-full overflow-hidden md:aspect-[4/3]">
                <img
                  src={item.poster}
                  alt={`${item.title} 经典剧集海报`}
                  title={`${item.title} 经典剧集海报`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/10 to-transparent"></div>
                <span className="absolute right-3 top-3 rounded-full bg-background-50/90 px-2.5 py-0.5 font-label text-xs font-bold text-accent-800">
                  {item.year}
                </span>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="font-heading text-base font-bold text-background-50 md:text-lg">{item.title}</h3>
                  <p className="mt-1 text-xs text-background-200">{item.meta}</p>
                </div>
              </div>
              <div className="flex items-center justify-between gap-2 p-4">
                <p className="line-clamp-2 text-xs leading-relaxed text-foreground-600">{item.desc}</p>
                <span className="flex shrink-0 items-center gap-1 font-heading text-sm font-bold text-accent-700">
                  <i className="ri-star-fill"></i>
                  {item.rating}
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}